import React, { useState } from "react";
import { useFormik } from "formik";
import InputField from "./InputField";
import { useDispatch } from "react-redux";
import { AddService } from "../store/service/actions/actionsCreators";
import { serviceSchema } from "../Schema/Schema";

const BookingForm = ({ serviceName }) => {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      appointmentDateTime: "",
      regPlateNumber: "",
      makeYear: "",
      name: "",
      email: "",
      phone: "",
      address: "",
      city: "",
      zip: "",
      notes: "",
    },
    validationSchema: serviceSchema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      try {
        const data = {
          ...values,
          appointmentDateTime: new Date(
            values.appointmentDateTime
          ).toISOString(),
          serviceName,
        };
        await dispatch(AddService(data));
        resetForm();
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="container mx-auto my-5">
      <div className="row">
        <div className="col-xxl-8 col-lg-7">
          <div className="card shadow-sm p-4 rounded-lg mx-auto">
            <div className="title-area mb-3 text-center">
              <h3 className="fw-bold" style={{ color: "#D74F1C" }}>
                Book Your Service Appointment for {serviceName}
              </h3>
              <p className="text-muted">
                Fill in the details below to book your appointment and get the
                best service for your car.
              </p>
            </div>

            <form onSubmit={formik.handleSubmit}>
              <div className="row gy-3">
                <div className="col-md-12">
                  <label className="form-label fw-semibold">
                    Appointment Date & Time *
                  </label>
                  <input
                    type="datetime-local"
                    name="appointmentDateTime"
                    className="form-control border-primary"
                    style={{
                      padding: "10px",
                      fontSize: "16px",
                      borderRadius: "8px",
                    }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.appointmentDateTime}
                  />
                  {formik.touched.appointmentDateTime &&
                  formik.errors.appointmentDateTime ? (
                    <div className="text-danger">
                      {formik.errors.appointmentDateTime}
                    </div>
                  ) : null}
                </div>
                <div className="col-md-6">
                  <InputField
                    label="Reg/Plate Number *"
                    name="regPlateNumber"
                    type="text"
                    value={formik.values.regPlateNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.regPlateNumber}
                    error={formik.errors.regPlateNumber}
                  />
                </div>

                <div className="col-md-6">
                  <InputField
                    label="Make"
                    name="makeYear"
                    type="text"
                    value={formik.values.makeYear}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.makeYear}
                    error={formik.errors.makeYear}
                  />
                </div>

                <div className="col-md-6">
                  <InputField
                    label="Name *"
                    name="name"
                    type="text"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.name}
                    error={formik.errors.name}
                  />
                </div>

                <div className="col-md-6">
                  <InputField
                    label="Email *"
                    name="email"
                    type="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.email}
                    error={formik.errors.email}
                  />
                </div>

                <div className="col-md-6">
                  <InputField
                    label="Phone *"
                    name="phone"
                    type="text"
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.phone}
                    error={formik.errors.phone}
                  />
                </div>

                <div className="col-md-6">
                  <InputField
                    label="Address *"
                    name="address"
                    type="text"
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.address}
                    error={formik.errors.address}
                  />
                </div>

                <div className="col-md-6">
                  <InputField
                    label="City *"
                    name="city"
                    type="text"
                    value={formik.values.city}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.city}
                    error={formik.errors.city}
                  />
                </div>

                <div className="col-md-6">
                  <InputField
                    label="Post Code *"
                    name="zip"
                    type="text"
                    value={formik.values.zip}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.zip}
                    error={formik.errors.zip}
                  />
                </div>

                <div className="col-md-12">
                  <label className="form-label fw-semibold">
                    Notes (Optional)
                  </label>
                  <textarea
                    name="notes"
                    className="form-control border-secondary"
                    onChange={formik.handleChange}
                    value={formik.values.notes}
                  ></textarea>
                </div>

                <div className="">
                  <button
                    type="submit"
                    className="btn style2"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        BOOK APPOINTMENT
                      </>
                    ) : (
                      "BOOK APPOINTMENT"
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="col-xxl-4 col-lg-5">
          <aside className="sidebar-area">
            <div className="widget widget_categories">
              <h3 className="widget_title">Contact Details</h3>
              <p>
                <strong>Call Us:</strong> 07496360002
              </p>
              <p>
                <strong>Email:</strong> inquiry@silverlineautoltd.co.uk
              </p>
              <p>
                <strong>Address:</strong> UNIT 2 POOL ROAD INDUSTRIAL ESTATE
                NUNEATON, CV10 9AE, United Kingdom
              </p>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default BookingForm;
